import { TextField, InputAdornment } from "@mui/material";
import { useState, useEffect } from "react";

const CurrencyTextField = ({ label, value, onChange, ...props }) => {
  const [internalValue, setInternalValue] = useState(value || "");

  useEffect(() => {
    setInternalValue(value || "");
  }, [value]);

  const handleChange = (e) => {
    let value = e.target.value.replace(/[^0-9,.]/g, ""); // Permite apenas números e vírgula
    value = value.replace(",", "."); // Troca vírgula por ponto

    // Remove zeros à esquerda, mantendo "0." se necessário
    value = value.replace(/^0+(\d)/, "$1");
    if (value.startsWith(".")) value = "0" + value; // Corrige ".5" para "0.5"

    // Permite apenas até duas casas decimais
    if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
      setInternalValue(value);
      if (onChange) onChange(value);
    }
  };

  return (
    <TextField
      label={label}
      type="text"
      InputProps={{
        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
        style: { textAlign: "right" },
      }}
      value={internalValue}
      onChange={handleChange}
      fullWidth
      autoComplete="new-password"
      {...props}
    />
  );
};

export default CurrencyTextField;
